import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    dots: {
      cursor: 'unset',
    },
    notSelected: {
      '&:hover': {
        background: '#F5F5F5;',
      },
    },
    number: {
      margin: '0px 4px',
    },
    page: {
      alignItems: 'center',
      borderRadius: '5px',
      color: '#999999',
      cursor: 'pointer',
      display: 'inline-flex',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      height: '25px',
      justifyContent: 'center',
      width: '25px',
    },
    selectedPage: {
      color: theme.palette.primary.main,
    },
  };
});
export default ({ count, page, rowsPerPage, changePage }) => {
  const [pageCount, setPageCount] = useState(Math.ceil(count / rowsPerPage));
  useEffect(() => {
    setPageCount(Math.ceil(count / rowsPerPage));
  }, [count, rowsPerPage]);
  const classes = useStyles();
  if (pageCount <= 1) {
    return null;
  }
  const pages = new Array(pageCount).fill(false);
  const dotLocations = [];
  // always display the first and last index
  pages[0] = true;
  pages[pages.length - 1] = true;

  // always display the selected page, the page before it and the page after it
  pages[page] = true;
  pages[Math.min(pages.length - 1, page + 1)] = true;
  pages[Math.max(0, page - 1)] = true;

  // if it is the first page, and there is at least 3 pages, make sure the third page is displayed
  if (page === 0 && pages.length >= 3) {
    pages[2] = true;
  }

  // if it is the last page, and there is at least 3 pages, make sure the third page from the end is displayed
  if (page === pages.length - 1 && pages.length >= 3) {
    pages[pages.length - 3] = true;
  }

  // if there is a gap between the first page and the page before selected page, display dots between them
  if (page - 1 >= 2) {
    dotLocations.push(0);
  }

  // if there is a gap between the last page and the page after selected page, display dots after the page after
  if (pages.length - page >= 3) {
    if (page === 0) {
      if (pages.length > 4) {
        dotLocations.push(Math.min(pages.length - 1, 2));
      }
    } else {
      dotLocations.push(Math.min(pages.length - 1, page + 1));
    }
  }

  const renderPages = () => {
    return pages.map((item, index) => {
      if (!item) return null;
      return (
        <>
          <span
            role="presentation"
            onClick={() => changePage(index)}
            onKeyDown={() => changePage(index)}
            className={`${classes.page} ${classes.number} ${index === page ? classes.selectedPage : classes.notSelected}`}>
            {index + 1}
          </span>
          {dotLocations.includes(index) && <span className={`${classes.page} ${classes.dots}`}>...</span>}
        </>
      );
    });
  };

  return (
    <div className="mt-1" style={{ textAlign: 'right' }}>
      <span
        role="presentation"
        onClick={() => changePage(Math.max(0, page - 1))}
        onKeyDown={() => changePage(Math.max(0, page - 1))}
        className={`${classes.page} ${classes.notSelected} `}>
        {' '}
        {'<'}{' '}
      </span>
      {renderPages()}
      <span
        role="presentation"
        onClick={() => changePage(Math.min(pages.length - 1, page + 1))}
        onKeyDown={() => changePage(Math.min(pages.length - 1, page + 1))}
        className={`${classes.page} ${classes.notSelected}`}>
        {' '}
        {'>'}{' '}
      </span>
    </div>
  );
};
